// Section7.jsx — Services: annotated banner + chip grid
import React from 'react';
import { useReveal, useTilt } from '../../componets/useScrollFX';
const servicesBanner = "../assets/Mobile App Development Services.png";

const Section7 = () => {
  const services = [
    "Custom mobile application development",
    "Android application development",
    "iOS application development",
    "Cross-platform app development",
    "Ecommerce mobile app development",
    "Enterprise mobility solutions",
    "UI/UX design",
    "API and third-party integrations",
    "Cloud-enabled mobile solutions",
    "Application maintenance and support"
  ];

  // Pin labels placed over the banner image, roughly matching the icon clusters in the artwork
  const pins = [
    { label: 'Design', top: '18%', left: '38%' },
    { label: 'Build', top: '46%', left: '58%' },
    { label: 'Secure', top: '72%', left: '46%' },
    { label: 'Scale', top: '30%', left: '78%' },
  ];

  const [headRef, headVisible] = useReveal();
  const [imgWrapRef, imgVisible] = useReveal();
  const [listRef, listVisible] = useReveal();
  const tilt = useTilt(6);

  return (
    <section id="services" className="bg-[#fafafa] py-10 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div
          ref={headRef}
          className={`max-w-3xl mb-16 transition-all duration-700 ${
            headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="text-[#cd2122] text-xs font-semibold uppercase tracking-widest">What We Offer</span>
          <h2 className="text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3 mb-6 leading-tight">
            Mobile App Development Services
          </h2>
          <p className="text-[#535353] text-[16px] leading-relaxed">
            Today, businesses use mobile technology. It helps them reach customers. It also boosts efficiency and creates new ways to earn money. Mean3 offers mobile app development services. These services help organizations achieve real business results.
          </p>
          <p className="text-[#535353] text-[16px] leading-relaxed mt-5">
            As a full-service mobile app development company, we support every stage of the app lifecycle from strategy and design to development, deployment, and ongoing optimization.
          </p>
        </div>

        <div className="flex flex-col-reverse md:flex-row gap-10 items-center">
          {/* Services chip grid */}
          <div
            ref={listRef}
            className={`transition-all duration-700 delay-200 ${
              listVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <h3 className="text-xl font-semibold text-[#1a1a1a] mb-7">
              Our Mobile App Development Services Include
            </h3>
            <div className="grid sm:grid-cols-2 gap-3">
              {services.map((service, index) => (
                <div
                  key={index}
                  style={{ transitionDelay: `${index * 50}ms` }}
                  className={`flex items-start gap-3 bg-white border border-gray-100 hover:border-[#cd2122] p-4 rounded-2xl transition-all duration-500 hover:shadow-lg hover:-translate-y-0.5 group ${
                    listVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                  }`}
                >
                  <span className="w-7 h-7 flex-shrink-0 rounded-full bg-[#cd2122]/10 text-[#cd2122] flex items-center justify-center text-sm group-hover:bg-[#cd2122] group-hover:text-white transition-colors duration-300">
                    ✓
                  </span>
                  <p className="text-[#535353] text-[15px] leading-snug pt-0.5">{service}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Annotated banner */}
          <div
            ref={(el) => { imgWrapRef.current = el; tilt.ref.current = el; }}
            onMouseMove={tilt.onMouseMove}
            onMouseLeave={tilt.onMouseLeave}
            style={{ ...tilt.style, transitionProperty: 'transform, opacity' }}
            className={`relative rounded-[2rem] overflow-hidden shadow-2xl border border-black/5 transition-all duration-700 delay-100 ${
              imgVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}
          >
            <img src={servicesBanner} alt="Mobile app development services" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/30 via-transparent to-transparent" />
            {pins.map((p, i) => (
              <div key={i} className="absolute" style={{ top: p.top, left: p.left, animation: `float${i % 2} 4s ease-in-out infinite` }}>
                <div className="relative flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-[#cd2122] ring-4 ring-white/40 animate-pulse" />
                  <span className="bg-white/95 backdrop-blur-sm text-[#1a1a1a] text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
                    {p.label}
                  </span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      <style>{`
        @keyframes float0 { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-8px); } }
        @keyframes float1 { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(8px); } }
      `}</style>
    </section>
  );
};

export default Section7;